<chr-illustration name="search-question" />

<ng-container *transloco="let t; read: 'COMMON.COLLECTIONS.EMPTY.NO_RESULTS'">
  <span data-test-id="noResultsHeader">{{ t("HEADER") }}</span>
  <p data-test-id="noResultsContent">{{ t("DESCRIPTION") }}</p>
</ng-container>
